module.exports = __webpack_public_path__ + "static/12-1db853e008199f7882ea86bdd931c59d.png";